function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}><defs><path d="M327.667 15.29l-5.167 5.166-5.167-5.167a.955.955 0 0 0-1.369 0l-.675.675a.955.955 0 0 0 0 1.369l5.167 5.167-5.167 5.167a.955.955 0 0 0 0 1.369l.675.675a.955.955 0 0 0 1.369 0l5.167-5.167 5.167 5.167a.955.955 0 0 0 1.369 0l.675-.675a.955.955 0 0 0 0-1.369l-5.167-5.167 5.167-5.167a.955.955 0 0 0 0-1.369l-.675-.675a.955.955 0 0 0-1.369 0z" id="a" /></defs><use fill="#278C7E" xlinkHref="#a" transform="translate(-315 -15)" /></svg>;
});